import React from 'react'

const Peru = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="45"
            height="40"
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask
                id="w"
                width="32"
                height="30"
                x="1"
                y="1"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#C4C4C4"
                    d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
                />
            </mask>
            <g mask="url(#w)">
                <path fill="#BA242A" d="M26.1.2H-6.2v18.84h32.3V.2Z" />
                <path fill="#fff" d="M13.28.2H6.62v18.84h6.66V.2Z" />
            </g>
        </svg>
    )
}

export default Peru
